import queryString from 'query-string';
import { useMemo, useCallback } from 'react';
import { jsx } from 'react/jsx-runtime';
import Link from 'next/link.js';

// src/connect/index.ts

// src/common/constant.ts
var ROUTES = {
  MY_ASSET: {
    INVEST: {
      INVESTMENT_DETAIL: "/mydata/myasset/invest/detail/account/:assetId",
      INVESTMENT_PAY_DETAIL: "/mydata/myasset/invest/detail/payAccount/:acctKey"
    },
    BANK: {
      DEPOSIT_STATEMENT: "/mydata/myasset/bank/deposit/:assetId/statement",
      FUND_STATEMENT: "/mydata/myasset/bank/fund/:assetId/statement",
      ISA_STATEMENT: "/mydata/myasset/bank/isa/:assetId/statement",
      PAY_STATEMENT: "/mydata/myasset/bank/pay/:acctKey/statement"
    }
  },
  CONNECT: {
    INDEX: "/mydata/connect"
  }
};

// src/connect/type.ts
var ConnectType = {
  NewConnection: "NewConnection",
  // 새 자산 연결
  ReconnectAllSkipFirst: "ReconnectAllSkipFirst",
  // 연결된 금융사 모두 갱신. 1차 스킵
  ReconnectWithOrgList: "ReconnectWithOrgList",
  // 만료 전/후 특정 금융사들을 갱신
  NewAsset: "NewAsset",
  // 새 자산 노티 통해서 연결하는 경우
  AddScopeWithOrgList: "AddScopeWithOrgList",
  // 특정 금융사들에 스코프만 추가하는 경우
  DisconnectAsset: "DisconnectAsset"
  // 1개 자산만 제외하고 다시 전송요구 전송
};
var CONNECT_SCHEME = {
  DEFAULT: "default",
  MYDATA_BANK: "mydata_bank",
  MYDATA_CARD: "mydata_card",
  MYDATA_INVEST: "mydata_invest",
  MYDATA_LOAN: "mydata_loan",
  MYDATA_PENSION: "mydata_pension",
  MYDATA_INSURANCE: "mydata_insurance",
  MYDATA_EFIN: "mydata_efin",
  INSURANCE_CAR: "car-insurance",
  INSURANCE_TIP: "insurance-tip",
  INSURANCE_FREE: "free-insurance",
  EXPIRE: "expire",
  PLACE: "place",
  REFINANCING: "refinancing",
  MORTGAGE: "mortgage",
  JEONSE: "jeonse",
  REMIT: "remit",
  SAVINGS: "savings",
  TAX_REFUND_BEFORE: "tax_refund_before",
  TAX_REFUND_AFTER: "tax_refund_after"
};
function useConnectPage(params, options) {
  const connectPage = useMemo(() => {
    return getConnectPagePath(params, options);
  }, [params, options]);
  const enterConnectPage2 = useCallback(() => {
    enterConnectPage(params, options);
  }, [params, options]);
  return { connectPage, enterConnectPage: enterConnectPage2 };
}
function useConnectAnchor(props) {
  return useMemo(() => {
    let href;
    if ("href" in props) {
      href = props.href;
    } else {
      href = getConnectPagePath(
        props.params,
        props.options
      );
    }
    const { newTab } = props.options || {};
    return { href, ...newTab && { target: "_blank", rel: "opener" } };
  }, [props]);
}
function ConnectAnchor(props) {
  const { children, ...rest } = props || {};
  const anchorAttr = useConnectAnchor(props);
  return /* @__PURE__ */ jsx("a", { ...anchorAttr, ...rest, children });
}
function ConnectLink(props) {
  const { children, ...rest } = props || {};
  const anchorAttr = useConnectAnchor(props);
  return /* @__PURE__ */ jsx(Link, { ...anchorAttr, ...rest, children });
}

// src/connect/index.ts
function getConnectPageRoute(params, options) {
  const { withQueries, ...connectOptions } = options || {};
  const queryObject = { ...withQueries, ...params, ...connectOptions };
  return {
    pathname: ROUTES.CONNECT.INDEX,
    query: queryString.stringify(queryObject, { arrayFormat: "none" }),
    queryObject
  };
}
function getConnectPagePath(params, options) {
  const { withQueries, ...connectOptions } = options || {};
  const queryObject = { ...withQueries, ...params, ...connectOptions };
  return `${ROUTES.CONNECT.INDEX}?${queryString.stringify(queryObject, { arrayFormat: "none" })}`;
}
function enterConnectPage(params, options) {
  const connectPagePath = getConnectPagePath(
    params,
    options
  );
  const { newTab } = options || {};
  if (newTab) {
    window.open(connectPagePath);
  } else {
    location.href = connectPagePath;
  }
}

export { CONNECT_SCHEME, ConnectAnchor, ConnectLink, ConnectType, enterConnectPage, getConnectPagePath, getConnectPageRoute, useConnectAnchor, useConnectPage };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map